module.exports = __webpack_public_path__ + "img/35310-115.b3fb2d47.jpg";